import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Townhomes banner',
    },
  },
};


export function TownhomesHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="townhomeshero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Townhomes banner"
    >
      <InnerPageHeroSubtitle path="townhomeshero.subtitle" />
      <RichTextContent
        path="townhomeshero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken path="townhomeshero.subtitle" type="richtext" as="span" className="hidden" style={{ display: 'none' }}>
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="townhomeshero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'TownhomesHero',
  displayName: 'Townhomes Hero',
  tokens: {
    'townhomeshero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Townhomes</p>',
    },
    'townhomeshero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue:
        '<p>Townhomes in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
      description:
        'Short, SEO-style headline for the townhomes page (e.g. "Townhomes in Tigard, OR").',
    },
  },
  slotGroups: {
    'townhomeshero.bg_image': bgImageDef,
  },
};

(TownhomesHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default TownhomesHero;
